import api from '../resources/privilege-templates.api';
import actionTypes from './action-types';

export const updatePrivilegeTemplateRequest = () => ({
  type: actionTypes.UPDATE_PRIVILEGE_TEMPLATE_REQUEST,
});

export const updatePrivilegeTemplateSuccess = (template) => ({
  type: actionTypes.UPDATE_PRIVILEGE_TEMPLATE_SUCCESS,
  template,
});

export const updatePrivilegeTemplateFailure = () => ({
  type: actionTypes.UPDATE_PRIVILEGE_TEMPLATE_FAILURE,
});

export const updatePrivilegeTemplate = (template) => async (dispatch) => {
  try {
    dispatch(updatePrivilegeTemplateRequest());

    const updatedTemplate = await api.updatePrivilegeTemplate(template);
    dispatch(updatePrivilegeTemplateSuccess(updatedTemplate));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('UPDATE_PRIVILEGE_TEMPLATE', error);
    dispatch(updatePrivilegeTemplateFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/actions/update-privilege-template.actions.js